/**
 * Returns true if the value param is empty.
 *
 * Curently only supports Array / Objects. Please add additional type checks as needed.
 *
 * @param {any} value Value to check as empty
 * @returns {boolean} Whether the value is empty or not
 *
 */

export const isEmpty = (value: unknown): boolean => {
	if (!value) {
		return true;
	}
	if (typeof value === 'string') {
		return !value;
	}
	if (typeof value === 'number') {
		return false;
	}
	if (Array.isArray(value)) {
		return !value.length;
	}
	if (value.constructor === Object) {
		return Object.keys(value).length === 0;
	}
	if (value.constructor === Map || value.constructor === Set) {
		return !value['size'];
	}

	console.warn(`isEmpty was unable to determine the type of parameter 'value':`, value);

	return true;
};
